<template>
  <div class="row d-flex justify-content-center">
    <div class="col-xl-8">
      <div v-if="!currentUser.userIsAnonymous">
        <form @submit.prevent="updateProfile">
          <h2 class="content-heading d-flex justify-content-between">
            <span><font-awesome-icon icon="user" fixed-width class="mr-1"/> User Profile</span>
            <button type="submit" class="btn btn-sm btn-primary" :disabled="loadingProfile">
              <font-awesome-icon v-if="!loadingProfile" icon="check" fixed-width class="mr-1"/><font-awesome-icon v-else icon="spinner" fixed-width class="mr-1 fa-spin"/> Update Profile
            </button>
          </h2>
          <div class="row push">
            <div class="col-md-6">
              <p class="text-muted">
                {{$t('user.settings.displayNameDesc1')}} {{$t('user.settings.displayNameDesc2')}}
              </p>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="display-name-input">{{$t('user.settings.displayName')}}</label>
                <input v-model="displayName" type="text" class="form-control" id="display-name-input" name="display-name-input" placeholder="Sherlock Holmes">
              </div>
            </div>
          </div>
        </form>
        <form>
          <h2 class="content-heading pt-5"><font-awesome-icon icon="envelope" fixed-width class="mr-1"/> {{$t('user.settings.emailAddress')}}</h2>
          <div class="row push">
            <div class="col-md-6">
              <p class="text-muted">
                {{$t('user.settings.emailAddressDesc1')}}
              </p>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="email-address-input">{{$t('user.settings.email')}}</label>
                <input v-model="currentUser.userEmail" type="email" class="form-control" id="email-address-input" name="email-address-input" disabled>
              </div>
            </div>
          </div>
        </form>
        <form v-if="currentUser.loginProvider === 'password'" @submit.prevent="updatePw">
          <h2 class="content-heading pt-5 d-flex justify-content-between">
            <span><font-awesome-icon icon="asterisk" fixed-width class="mr-1"/> Change Password</span>
            <button type="submit" class="btn btn-sm btn-primary" :disabled="loadingPw">
              <font-awesome-icon v-if="!loadingPw" icon="check" fixed-width class="mr-1"/><font-awesome-icon v-else icon="spinner" fixed-width class="mr-1 fa-spin"/> Update Password
            </button>
          </h2>
          <div class="row push">
            <div class="col-md-6">
              <p class="text-muted">
                Change you password. Hide and Show what you typed by clicking the eye icon.
              </p>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="password-input">New Password</label>
                <div class="input-group">
                  <input :type="pwInput.type" v-model="password" class="form-control" id="password-input" name="password-input" placeholder="Password">
                  <div @click="showPw = !showPw" class="input-group-append">
                    <span class="input-group-text">
                       <font-awesome-icon :icon="pwInput.icon" fixed-width/>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <form @submit.prevent="deleteAccount">
          <h2 class="content-heading pt-8 d-flex justify-content-between text-danger">
            <span><font-awesome-icon icon="exclamation-triangle" fixed-width class="mr-1"/> Danger Zone</span>
            <button type="submit" class="btn btn-sm btn-danger" :disabled="!deleteAccountToggle || loadingDelete">
              <font-awesome-icon v-if="!loadingDelete" icon="trash" fixed-width class="mr-1"/><font-awesome-icon v-else icon="spinner" fixed-width class="mr-1 fa-spin"/> Delete Account
            </button>
          </h2>
          <div class="row push">
            <div class="col-md-6">
              <p class="text-muted">
                This action is permanent and can NOT be undone!
              </p>
            </div>
            <div class="col-md-6">
              <b-form-checkbox
                id="checkbox1"
                name="checkbox1"
                v-model="deleteAccountToggle"
                switch
              >
                I accept and are aware of that this action is permanent and can NOT be undone!
              </b-form-checkbox>
            </div>
          </div>
        </form>
      </div>
      <div class="block-content" v-else>
        <h2 class="text-center">{{$t('user.settings.guestSettingsError')}}</h2>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
const fb = require('@/firebaseConfig.js')

export default {
  name: 'settings',
  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    },
    displayName: {
      get () {
        return this.$store.getters.currentUser.displayName
      },
      set (value) {
        this.$store.commit('updateUserProfile', { key: 'displayName', value: value })
      }
    },
    pwInput () {
      if (this.showPw) return { type: 'text', icon: 'eye-slash' }
      else return { type: 'password', icon: 'eye' }
    }
  },
  data () {
    return {
      loadingProfile: false,
      loadingPw: false,
      loadingDelete: false,
      password: '',
      showPw: false,
      deleteAccountToggle: false
    }
  },
  methods: {
    ...mapMutations([
      'setNotification',
      'resetUser'
    ]),
    updateProfile () {
      this.loadingProfile = true
      fb.auth.currentUser.updateProfile({
        displayName: this.displayName
      })
        .then(() => {
          this.setNotification({
            variant: 'success',
            message: 'Changes to User Profile successfully saved!'
          })
          this.loadingProfile = false
        })
        .catch((error) => {
          this.setNotification({
            variant: 'danger',
            message: error.message
          })
          this.loadingProfile = false
        })
    },
    updatePw () {
      this.loadingPw = true
      fb.auth.currentUser.updatePassword(this.password)
        .then(() => {
          this.setNotification({
            variant: 'success',
            message: 'New Password successfully set!'
          })
          this.loadingPw = false
          this.password = ''
        })
        .catch((error) => {
          this.setNotification({
            variant: 'danger',
            message: error.message
          })
          this.loadingPw = false
        })
    },
    deleteAccount () {
      this.loadingDelete = true
      fb.auth.currentUser.delete()
        .then(() => {
          fb.auth.signOut().then(() => {
            this.resetUser()
            this.$router.replace('/')
            this.setNotification({
              variant: 'warning',
              message: 'Your account has successfully been deleted!'
            })
          })
          this.loadingDelete = false
        })
        .catch((error) => {
          this.setNotification({
            variant: 'danger',
            message: error.message
          })
          this.loadingDelete = false
        })
    }
  }
}
</script>

<style scoped>
  .input-group-append {
    cursor: pointer;
  }
</style>
